<div class="au-filters multitext-search-filter" (click)="$event.stopPropagation()">
	<mat-form-field hideRequiredMarker class="au-search-input no-label" floatLabel="never">
		<input
			autocomplete="off"
			type="text"
			matInput
			[placeholder]="'type_value' | translate"
			auMatInputAutofocus
			[formControl]="searchControl"
		/>
		@if (searchControl.hasError('invalid')) {
			<mat-error>
				Invalid format. Please enter numbers separated by a semicolon.
			</mat-error>
		}
	</mat-form-field>
</div>
